import React, { Component } from "react";
import PropTypes from "prop-types";
import slugify from "slugify";
import styles from "./index.module.css";

import Chart from "../Chart";
import Table from "../Table";
import SelectControl from "../SelectControl";
import FigureFooter from "../FigureFooter";

/**
 * Wrapper around charts and tables. Provides switching, download and sharing
 * functionality.
 */
class BlockChart extends Component {
  constructor(props) {
    super(props);
    let selectedGroupId = 0;
    if (props.groups) {
      selectedGroupId = props.groups[0].id;
    }
    this.state = { selectedGroupId };

    this.onGroupChange = this.onGroupChange.bind(this);
  }

  // Recreate the charts config using the newly selected group
  onGroupChange(event) {
    const selectedGroupId = parseInt(event.target.value, 10);
    this.setState({ selectedGroupId });
  }

  render() {
    const {
      chartId,
      type,
      title,
      insight,
      groups,
      onDownloadClick,
      sources,
      note
    } = this.props;
    if (!groups) return <div className={styles.root} />;
    const selectedGroupId = this.state.selectedGroupId;
    let selectedGroup = groups.find(group => group.id === selectedGroupId);
    if (!selectedGroup) {
      selectedGroup = groups[0];
    }
    const isTable = type === "table";
    const Figure = isTable ? Table : Chart;
    const slug = title ? slugify(title) : "";

    return (
      <div className={styles.root}>
        {insight && <h1 className={styles.insight}>{insight}</h1>}
        {title && (
          <h2 id={slug} className={styles.title}>
            {title}
          </h2>
        )}
        <div className={styles.select}>
          {groups.length > 1 && (
            <SelectControl
              values={groups}
              selectedId={selectedGroupId}
              onChange={this.onGroupChange}
            />
          )}
        </div>
        <div className={styles.figure}>
          <Figure {...this.props} groups={null} group={selectedGroup}>
            <FigureFooter
              onDownloadClick={
                onDownloadClick
                  ? () => onDownloadClick(chartId, selectedGroup.id)
                  : null
              }
              sources={sources}
              note={note}
              chartId={chartId}
              groupId={selectedGroup.id}
              title={title}
              slug={slug}
            />
          </Figure>
        </div>
      </div>
    );
  }
}

BlockChart.defaultProps = {
  groups: []
};

BlockChart.propTypes = {
  title: PropTypes.string,
  insight: PropTypes.string,
  type: PropTypes.oneOf([
    "column",
    "bar",
    "line",
    "pie",
    "column_line",
    "table"
  ]),
  onDownloadClick: PropTypes.func,
  chartId: PropTypes.number,
  sources: PropTypes.string,
  note: PropTypes.string,
  // Highcharts data
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      categories: PropTypes.arrayOf(PropTypes.string),
      name: PropTypes.string,
      series: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          data: PropTypes.array // numbers or objects
        })
      )
    })
  )
};

export default BlockChart;



// WEBPACK FOOTER //
// ./src/components/BlockChart/index.js